<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.PRODUCT_CODE+' - '+r.TRADE_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="'Manage Combo Products'" [icon]="'fa-gift'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row">
    <div class="col-lg-2">
      <label>Description</label>
    </div>
    <div class="col-lg-8">
      <input [(ngModel)]="combo.description" class="form-control " maxlength="250" name="description"
             type="text">
    </div>
  </div>
  <hr>
  <h5 class="list-header">Add Products</h5>
  <div class="clearfix"></div>
  <div class=" form-group">
    <table class=" table tbl  table-bordered ">
      <thead>
      <tr class="text-center">
        <th class="text-center" width="1%">#</th>
        <th>Item<span class="text-danger">*</span></th>
        <th width="8%">Base Price</th>
        <th width="8%">Available Qty</th>
        <th width="8%">Qty</th>
        <th width="8%">Cost</th>
        <th width="12%">Slab</th>
        <th width="8%">Slab Price</th>
        <th width="7%">Price</th>
        <th width="7%">Margin</th>
        <th width="7%">MRP</th>
        <th width="1%">*</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let i of utils.buildArray(combo_details.length)">
        <td>{{ i + 1 }}</td>
        <td>
          <input (focusout)="totalprice()" (selectItem)="set_item_medicine($event,i)"
                 [(ngModel)]="combo.medicine_data[i]" [class.is-invalid]="searchFailed"
                 [inputFormatter]="formatter" [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search"
                 [resultTemplate]="rt" class="form-control"
                 id="typeahead-http{{i}}" placeholder="Search Particular Name...."
                 type="text"/>
        </td>
        <td class="text-right">
          <input (focusout)="totalPrice();" [(ngModel)]="combo.base_price[i]" [readOnly]="true"
                 class="form-control  "
                 maxlength="20" name="base_price{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input [(ngModel)]="combo.available_qty[i]" [readOnly]="true" class="form-control  "
                 name="available_qty{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <input (focusout)="totalprice()" (keydown)="totalprice()" [(ngModel)]="combo.quantity[i]"
                 class="form-control  "
                 maxlength="8" name="quantity{{i}}" type="text">
        </td>
        <td>
          <input [(ngModel)]="combo.cost[i]" [readOnly]="true" class="form-control  " maxlength="8"
                 name="cost{{i}}" type="text">
        </td>
        <td>
          <select (change)="getSlab(i);totalprice()" (focusout)="totalprice();getPrice(i);" (keydown)="totalprice()"
                  [(ngModel)]="combo.slab[i]"
                  class="form-control  custom-select custom-select-sm" id="sel_dr" name="sel_dr">
            <option value="">Select Slab</option>
            <option value="1">Slab A</option>
            <option value="2">Slab B</option>
            <option value="3">Slab C</option>
          </select>
        </td>
        <td class="text-right">
          <input (focusout)="totalprice()" [(ngModel)]="combo.slab_price[i]" [readOnly]="true"
                 class="form-control text-right "
                 maxlength="10" name="slab_price{{i}}" tabindex="-1" type="text">
        </td>
        <td class="text-right">
          <input (focusout)="totalprice()" [(ngModel)]="combo.price[i]" [readOnly]="true"
                 class="form-control  text-right " maxlength="7"
                 name="price{{i}}" tabindex="-1" type="text">
        </td>
        <td class="text-right">
          <input (focusout)="totalprice()" [(ngModel)]="combo.margin[i]" [readOnly]="true"
                 class="form-control text-right  " maxlength="7"
                 name="MRP{{i}}" tabindex="-1" type="text">
        </td>
        <td class="text-right">
          <input (focusout)="totalprice()" [(ngModel)]="combo.MRP[i]" [readOnly]="true"
                 class="form-control text-right  " maxlength="7"
                 name="MRP{{i}}" tabindex="-1" type="text">
        </td>
        <td>
          <button (click)="addrow(i)" *ngIf="i == combo_details.length-1" alt="Add New data"
                  class="btn btn-success btn-sm " title="Add New data" type="button"><i class="fa fa-plus"
                                                                                        style="color: white;"></i>
          </button>
          <button (click)="deleterow(i)" *ngIf="i  != combo_details.length-1" alt="Delete data"
                  class="btn btn-danger  btn-sm " title="Delete data" type="button"><i class="fa fa-trash"
                                                                                       style="color: white;"></i>
          </button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="5">Total Price</td>
        <td class="text-right">{{ total_cost| number : '1.2-2' }}</td>
        <td class="text-right" colspan="2"></td>
        <td class="text-right">{{ total_price| number : '1.2-2' }}</td>
        <td class="text-right">{{ total_margin| number : '1.2-2' }}</td>
        <td class="text-right">{{ total_mrp| number : '1.2-2' }}</td>
      </tr>
      </tfoot>
    </table>
    <div class="clearfix"></div>
  </div>
  <div class="clearfix"></div>
  <hr>
  <div class="clearfix"></div>
  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="saveComboProduct();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>
    </div>
  </div>
  <div style="height:100px"></div>

  <div class="clearfix"></div>
</div>
